import { Grid } from '@material-ui/core';
import React from 'react';
import { FiGitMerge } from "react-icons/fi";
import { FaHandshake, FaList } from 'react-icons/fa';
import { IoMdGitMerge } from 'react-icons/io';
import { RiFileList2Fill, RiPlayListAddFill } from 'react-icons/ri';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../hooks/auth';
import {
  CarIcon,
  FileAltIcon,
  HandHoldingHeartIcon,
  HandsHelpingIcon,
  ListIcon,
  PersonAdd,
  PersonIcon,
  PoliceCarFill,
  SupportIcon,
  UserSearchFill,
  UsersIcon,
} from '../../../styles/icons';
import { Button, Container } from './styles';

const Favorites: React.FC = () => {
  const history = useHistory();
  const { user, iCan } = useAuth();

  return (
    <Container>
      <Grid container spacing={2}>
        {iCan('c-social-action') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('/social-action')}
              >
                <FaHandshake size={32} />
                Criar Ação Social
              </Button>
            </Grid>
          </>
        )}

        {iCan('r-social-action') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('/social-action/list')}
              >
                <RiFileList2Fill size={32} />
                Listar Ações Sociais
              </Button>
            </Grid>
          </>
        )}

        {iCan('c-partner') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('social-action/partners/create')}
              >
                <PersonAdd size={32} />
                Criar Parceiro
              </Button>
            </Grid>
          </>
        )}

        {iCan('r-partner') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('social-action/partners')}
              >
                <UsersIcon size={32} />
                Listar Parceiros
              </Button>
            </Grid>
          </>
        )}

        {iCan('c-service-social-action') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('social-action/services/create')}
              >
                <RiPlayListAddFill size={32} />
                Criar Serviço
              </Button>
            </Grid>
          </>
        )}

        {iCan('r-service-social-action') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('/social-action/services')}
              >
                <FaList size={32} />
                Listar Serviços
              </Button>
            </Grid>
          </>
        )}

        {iCan('c-partner-service') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('social-action/partners-services')}
              >
                <FiGitMerge size={32} />
                Criar Vínculo para Ação RJ
              </Button>
            </Grid>
          </>
        )}

        {iCan('r-partner-service') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('social-action/partners-services')}
              >
                <IoMdGitMerge size={32} />
                Listar Vínculos das Ações RJ
              </Button>
            </Grid>
          </>
        )}

        {iCan('c-orders') && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('/order/vehicle')}
              >
                <CarIcon size={32} />
                Consultar Veículo
              </Button>
            </Grid>
           {iCan('admin') && (
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  type="button"
                  onClick={() => history.push('/order/person2')}
                >
                  <PersonIcon size={32} />
                  Consultar Pessoa (PARADO)
                </Button>
              </Grid>
            )}
            
             
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  type="button"
                  onClick={() => history.push('/order/person')}
                >
                  <PersonIcon size={32} />
                  Consultar Pessoa
                </Button>
              </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <Button
                type="button"
                onClick={() => history.push('/orders/latest')}
              >
                <ListIcon size={32} />
                Consultas Recentes
              </Button>
            </Grid>
          </>
        )}

        {user?.is_intelligence && (
          <Grid item xs={12} sm={6} md={4} className="displayNone">
            <Button
              type="button"
              onClick={() => history.push('/orders/awaiting')}
            >
              <ListIcon size={32} />
              Fechar Consultas
            </Button>
          </Grid>
        )}

        {iCan('c-proximity') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button
              type="button"
              onClick={() => history.push('/orders/proximity')}
            >
              <HandsHelpingIcon size={32} />
              Abordagem de Proximidade
            </Button>
          </Grid>
        )}

        {iCan('c-social') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button type="button" onClick={() => history.push('/social')}>
              <HandHoldingHeartIcon size={32} />
              Abordagem Social
            </Button>
          </Grid>
        )}
        {iCan('c-bdtd') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button type="button" onClick={() => history.push('/bdtd')}>
              <PoliceCarFill size={32} />
              BDTD
            </Button>
          </Grid>
        )}
        {iCan('c-sinalid') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button type="button" onClick={() => history.push('/sinalid')}>
              <UserSearchFill size={32} />
              Sinalid
            </Button>
          </Grid>
        )}
        {iCan('c-rosp') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button type="button" onClick={() => history.push('/RO')}>
              <FileAltIcon size={32} />
              RO-SP
            </Button>
          </Grid>
        )}
        {iCan('c-technician') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button type="button" onClick={() => history.push('/support/awaiting')}>
              <SupportIcon size={32} />
              Suporte L8
            </Button>
          </Grid>
        )}
        {iCan('r-technician') && (
          <Grid item xs={12} sm={6} md={4}>
            <Button type="button" onClick={() => history.push('/support/technician')}>
              <SupportIcon size={32} />
              Técnico L8
            </Button>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default Favorites;
